<template>
  <div :class="['container', specificClassName, {active: isActive}]"
       @click="activeInput">
    <span :class="iconClassName"/>
    <input v-model="value"
           ref="input"
           :disabled="!isActive"
           :placeholder="placeholder"
           @keyup.enter="emitShowModal"
           @blur="closeOnWindowClick($event)"
    />
  </div>
</template>

<script>
  import UniversalModal from "./UniversalModal";

  export default {
    name: "SearchBAF",
    components: {UniversalModal},
    props: ['iconClassName', 'placeholder', 'specificClassName', 'isModalVisible'],
    data() {
      return {
        isActive: false,
        value: '',
      }
    },
    watch: {
      isActive(value, oldValue) {
        if (!value) {
          this.value = '';
        }
      }
    },
    methods: {

      closeOnWindowClick(e) {
        let target = e.target;

        while (target instanceof Element) {

          if (target.classList.contains(this.specificClassName) ||
              target.classList.contains(this.iconClassName)) {
            return;
          }

          target = target.parentNode;
        }

        this.isModalVisible ? this.isActive = false : '';
        this.value = "";
      },

      activeInput() {
        this.isActive = true;
      },

      fanTypeNumberCheck() {
        let query = this.value;
        let form = new FormData();
        form.append('type_number', query);
        this.$apiController.getFanByTypeNumberHandshake(form)
            .then((res) => {
              if (res.status === 'error') {
                this.$notifications.add(this.$notifications.TYPES.WARNING, 'BAFA / ERP', this.translate(res.message));
              } else if (res.status === 'success') {
                const defaultNetworkFrequencyOptionId = 0;
                const defaultNetworkFrequencyElementId = 0;

                this.$store.commit({
                  type: 'selectElementOfOptionInParamBaf',
                  param_id: 'network_frequency',
                  option_id: defaultNetworkFrequencyOptionId,
                  element_id: defaultNetworkFrequencyElementId
                });

                this.$store.state.bafaParameters.work_frequency.options[0].locked = this.$store.state.bafaParameters.work_on_the_inverter.options[0].elements[0].active;
                this.$store.state.bafaParameters.work_frequency.options[0].min_value = res.data.min_frequency;
                this.$store.state.bafaParameters.work_frequency.options[0].max_value = res.data.max_frequency;
                this.$store.state.bafaParameters.work_frequency.options[1].value_min = res.data.min_frequency;
                this.$store.state.bafaParameters.work_frequency.options[1].value_max = res.data.max_frequency;

                if (res.data.fan_max_frequency > 50) {
                  this.$store.state.bafaParameters.network_frequency.options["0"].elements["1"].locked = false;
                } else {
                  this.$store.state.bafaParameters.network_frequency.options["0"].elements["1"].locked = true;
                }

                for (let optionId in this.$store.state.bafaParameters.work_on_the_inverter.options) {
                  const option = this.$store.state.bafaParameters.work_on_the_inverter.options[optionId];

                  if (option.type === 'radio') {
                    for (let elementId in option.elements) {
                      const element = option.elements[elementId];
                      element.active = element.default;
                    }
                  }
                }

                this.$store.state.bafaParameters.work_frequency.options[0].value = this.$store.state.bafaParameters.network_frequency.options[defaultNetworkFrequencyOptionId].elements[defaultNetworkFrequencyElementId].value;

                Vue.set(this.$store.state, 'bafaSearchQuery', this.value);
                this.isActive = false;
                this.$parent.$emit('showModal', {
                  modalHeader: 'ERP / BAFA',
                  modalContent: '',
                  view: '/bafa_tables',
                  modalButtonTitle: 'find'
                });
              }
            })
      },

      translate(code, displayErrors = true) {
        let arg = {
          type: 'translate',
          code: code,
          displayErrors: displayErrors,
          out: ""
        }

        this.$store.commit(arg);

        return arg.out;
      },

      emitData() {
        this.$parent.$emit('searchData', {
          value: this.value,
        });
      },

      emitShowModal() {
        this.fanTypeNumberCheck();
      }
    },

    mounted() {
      window.addEventListener('click', this.closeOnWindowClick.bind(this));

      this.$parent.$on('getSearchData', () => {
        this.emitData();
      });
    },

    beforeDestroy() {
      window.removeEventListener('click', this.closeOnWindowClick.bind(this));
    }
  }
</script>
